import React from 'react';
import { useAuth } from './hooks/useAuth';
import { useSocket } from './hooks/useSocket';
import { MapView } from './components/MapView';
import { LoginPage } from './components/LoginPage';
import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'CircularXX';
    src: url('/CircularXX-Book_9b74446c.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Circular';
    src: url('/CircularLLVIPWeb-Upright.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Circular';
    src: url('/CircularLLVIPWeb-Italic.woff2') format('woff2');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'CircularXX', 'Circular', -apple-system, BlinkMacSystemFont, 'Segoe UI',
      'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    overflow: hidden;
  }

  #root {
    height: 100vh;
    overflow: hidden;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #F7F8F9;
  color: #4D546D;
  font-size: 17px;
  font-weight: 450;
`;

function App() {
  const { authenticated, loading: authLoading, authError, user } = useAuth();
  const { users, teams, activities, workspaceTeamId } = useSocket(authenticated);

  return (
    <>
      <GlobalStyle />

      {authLoading ? (
        <LoadingContainer>
          Loading...
        </LoadingContainer>
      ) : !authenticated ? (
        <LoginPage authError={authError} />
      ) : users.length === 0 ? (
        <LoadingContainer>
          Loading office map...
        </LoadingContainer>
      ) : (
        <MapView
          users={users}
          teams={teams}
          workspaceTeamId={workspaceTeamId}
          activities={activities}
          userEmail={user?.email}
        />
      )}
    </>
  );
}

export default App;
